window.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'IFRAME_READY') {
    const urlParams = new URLSearchParams(window.location.search);
    const gclid = urlParams.get('gclid');
    
    if (gclid) {
      // Reply directly to the iframe that sent the message
      event.source.postMessage({ type: 'SET_GCLID', gclid: gclid }, event.origin);
    }
  }
});